import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { COOKIE_CONFIG, COOKIE_KEYS } from '../../../../lib/constants';

/**
 * デバイス認証コードによるデバイス認証を行うAPIを呼び出す
 *
 * @param {string} apiToken - API認証トークン
 * @param {string} deviceAuthCode - デバイス認証コード
 * @param {function} setCookie - Cookieを設定する関数
 * @returns
 */
const checkDeviceAuthCode =
  (apiToken, deviceAuthCode, setCookie) => dispatch => {
    consolelog('[API CALL] deviceAuthCode()');
    configureAxiosForJSON(apiToken);
    const url = endpoint.API_CHECK_DEVICE_AUTH_CODE;
    const { cancelToken, cancelTokenKey } = createCancelToken('deviceAuthCode');

    // 呼び出し側で非同期処理の結果を処理するために、Promiseオブジェクトを返す
    return new Promise((resolve, reject) => {
      axios
        .post(
          url,
          {
            code: deviceAuthCode,
          },
          {
            cancelToken,
          },
        )
        .then(res => {
          dispatch({
            type: actionTypes.SUCCESS_API_CHECK_DEVICE_AUTH_CODE,
            payload: res.data,
          });
          setCookie(
            COOKIE_KEYS.DEVICE_AUTH_TOKEN,
            res.data.deviceAuthToken,
            COOKIE_CONFIG[COOKIE_KEYS.DEVICE_AUTH_TOKEN],
          );
          resolve(res.data);
        })
        .catch(thrown => {
          if (!axios.isCancel(thrown)) {
            // 認証コードが不正な場合
            if (
              thrown.response &&
              thrown.response.status === 401 &&
              thrown.response.data.errorCode === 'invalid_code'
            ) {
              dispatch({
                type: actionTypes.ERROR_API_CHECK_DEVICE_AUTH_CODE,
              });
            }
            // 認証コードが期限切れの場合
            else if (thrown.response && thrown.response.status === 403) {
              const buttonClose = i18nMessages['userPrompt.button.close'];
              const outMessage = [
                i18nMessages['userPrompt.message.deviceAuth.confirm.error'],
                i18nMessages['userPrompt.message.deviceAuth.resource.expired'],
              ];
              dispatch({
                type: actionTypes.OPEN_USER_PROMPT,
                promptMessage: outMessage,
                buttonArray: [{ name: buttonClose, type: 1 }],
              });
            }
            // その他のエラーは共通エラーハンドリングを行う
            else {
              handleErrorResponse(
                thrown,
                dispatch,
                '',
                i18nMessages['userPrompt.message.deviceAuth.confirm.error'],
              );
            }
          }
          reject(thrown);
        })
        .finally(() => delCancelToken(cancelTokenKey));
    });
  };

export default checkDeviceAuthCode;
